import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from '../utils/config';
import { setEmailPreference } from './application';
import { onErrorHandler } from './handlers';

declare const window: any;

export const customerGdprAPI = createApi({
    reducerPath: 'customerGdprAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: '',
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8")
            return headers
        },
    }),
    tagTypes: ['customerGdpr'],
    endpoints: (builder) => ({
        setContactPreference: builder.mutation({
            query: ({ ...data }) => ({
                url: `${window.Config?.GDPR_PUT_API}` ?? 'https://npr-customer.api.pens.com/v1/setCustomerEmailPreference',
                method: 'PUT',
                body: {
                    ...data,
                }
            }),
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data;
                }
                catch (error) {
                    dispatch(onErrorHandler({operation: 'set contact preference', err: JSON.stringify(error), errMsg: 'Error: while setting contact preference', api: `${window.Config.GDPR_PUT_API}`}));
                }
            }
        }),
        getContactPreference: builder.mutation({
            query: ({ email }) => ({
                url: `${window.Config?.GDPR_GET_API ?? 'https://npr-customer.api.pens.com/v1/getCustomerEmailPreference'}?emailaddress=${email}&countrycode=${config('regionCode')}` ?? `https://npr-customer.api.pens.com/v1/getCustomerEmailPreference?emailaddress=${email}&countrycode=${config('regionCode')}`,
                method: 'GET'
            }),
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    args?.currentPage === 'myaccount' && dispatch(setEmailPreference({emailAddress: data?.data?.emailAddress, subscribe: data?.data?.subscribe}))
                    return data;
                }
                catch (error) {
                    dispatch(onErrorHandler({operation: 'get contact preference', err: JSON.stringify(error), errMsg: 'Error: while obtaining contact preference', api: `${window.Config.GDPR_GET_API}`}));
                }
            }
        }),
    }),
})

export const {
    useSetContactPreferenceMutation,
    useGetContactPreferenceMutation,
} = customerGdprAPI;